/*******************************************************************************
 * File: PlanAndBook.js
 * Summary:
 ******************************************************************************/

/*******************************************************************************
 * Section: Imports
 ******************************************************************************/
import '../assets/css/app.css'
import '../assets/css/loading-spinner.css'
import styled from 'styled-components'

import iconArrowRight from '../assets/icon/arrow-right.png'
import iconArrowsLeftRight from '../assets/icon/arrows-left-right.png'
import iconHelp from '../assets/icon/question-mark.svg'
import iconArrowRightSmall from '../assets/icon/arrow-right-small.png'
import iconCalender from '../assets/icon/calender.png'

/*******************************************************************************
 * Section: Custom Divs
 ******************************************************************************/

const SearchFlightBox = styled.div`
  margin: 0px auto 0px;
  // max-width: 1059px;
  max-width: 1465px;
  min-height: 294px;
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
`

const HeaderRow = styled.div`
  overflow: hidden;
  padding: 12px 25px;
  min-height: 49px;
  border-bottom: 1px solid #222;
  background-color: #2b3d2b;
  border-radius: 8px;
  margin-bottom: 10px;
`

const HeaderText = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;

  margin-right: 40px;
  color: #ffffff;
  vertical-align: middle;
`

const HeaderButton = styled.button`
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;

  background-color: transparent;
  color: #ffffff;
  padding: 0px 15px;
  border: solid;
  border-width: 1px;
  border-radius: 14px;
  height: 27px;
  margin-right: 5px;
`
const Selectors = styled.div`
  float: right;
`
const IconHelp = styled.img`
  margin-left: 5px;
  height: 14px;
  vertical-align: middle;
`

const HelpText = styled.p`
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;

  display: inline;
  margin-left: 2px;
  color: #ffffff;
`

const OptionsRow = styled.div`
  box-shadow: 0 0 2px 1px rgba(38, 38, 38, 0.2);
  border-radius: 7px;
  background: #ffffff;
`

const Filters = styled.div`
  overflow: hidden;
  padding: 12px 25px;
  min-height: 49px;
  font-size: 12px;
`

const Filter = styled.span`
  margin-right: 25px;
  height: 100%;
  display: inline-block;
`

const AdvancedSearch = styled.div`
  float: right;
  font-size: 12px;
`

const Locations = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 25px;
  overflow: hidden;
`

const Dates = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 25px;
  overflow: hidden;
`

const Details = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 25px;
  overflow: hidden;
`

const InputWrapperNormal = styled.div`
  margin-bottom: 25px;
  height: 44px;
  border: 1px solid #d3d2c9;
  border-radius: 22px;
  display: flex;
  @media (min-width: 720px) {
    width: 50%;
  }
`

const InputWrapperNarrow = styled.div`
  float: left;
  margin-bottom: 25px;
  height: 44px;
  border: 1px solid #d3d2c9;
  border-radius: 22px;
  display: flex;

  @media (min-width: 720px) {
    margin-right: 25px;
    width: 25%;
  }
`

const Label = styled.label`
  margin: 12px 0;
  padding: 0 12px 0 18px;
  font-size: 14px;
  color: #4c3de3;
  border-right: 1px solid #d3d2c9;
`

const Input = styled.input`
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;

  padding: 11px;
  font-size: 16px;
  font-weight: bold;
  color: #000;
  border: none;
  background: none;
  flex-grow: 1;
`

const FindFlightsButton = styled.button`
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  height: 46px;
  width: 187px;

  color: #000000;
  border: solid;
  border-width: 1px;
  border-radius: 31px;
  background-color: #ffffff;
  padding: 0px 0px;
`

const IconArrow = styled.img`
  float: left;
  margin-top: 6px;
  width: 30px;
  height: 30px;
  vertical-align: middle;
  @media (min-width: 720px) {
    display: block;
  }
`
const ButtonGroup = styled.div`
  width: 100%;
`

const CalenderIcon = styled.img`
  height: 15px;
  margin: 15px;
`

/*******************************************************************************
 * Function: Header
 * Summary: Renders Header across all pages for website
 ******************************************************************************/

// Function to format date as "Friday, August 11th, 2025"
function formatDateToText(date) {
  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }

  const formatted = date.toLocaleDateString('en-US', options)

  // Add ordinal suffix (st, nd, rd, th) to the day
  return formatted.replace(
    /(\w+), (\w+) (\d+), (\d+)/,
    (match, weekday, month, day, year) => {
      const dayNum = parseInt(day)
      let suffix = 'th'

      if (dayNum % 100 !== 11 && dayNum % 100 !== 12 && dayNum % 100 !== 13) {
        if (dayNum % 10 === 1) suffix = 'st'
        else if (dayNum % 10 === 2) suffix = 'nd'
        else if (dayNum % 10 === 3) suffix = 'rd'
      }

      return `${weekday}, ${month} ${dayNum}${suffix}, ${year}`
    }
  )
}

function PlanAndBook(props) {
  let today = new Date()
  let weekFromNow = new Date(new Date().setDate(today.getDate() + 7))

  let todayFormated = formatDateToText(today)
  let weekFromNowFromated = formatDateToText(weekFromNow)

  return (
    <SearchFlightBox>
      <HeaderRow>
        <HeaderText>Book a trip</HeaderText>
        <HeaderText>Manage your trips</HeaderText>
        <HeaderText>Check-in</HeaderText>
        <HeaderText>Flight status</HeaderText>
        <Selectors>
          <HeaderButton>Hotels</HeaderButton>
          <HeaderButton>Cars</HeaderButton>
          <HeaderButton>Packages</HeaderButton>
          <IconHelp src={iconHelp} alt="" />
          <HelpText>Help</HelpText>
        </Selectors>
      </HeaderRow>

      <OptionsRow>
        <Filters>
          <Filter>
            <Input type="checkbox" /> Round Trip
          </Filter>
          <Filter>
            <Input type="checkbox" /> One Way
          </Filter>
          <Filter>
            <Input type="checkbox" /> Book with Miles
          </Filter>
          <Filter>
            <Input type="checkbox" /> Flexible Dates
          </Filter>
          <AdvancedSearch>
            Advanced Search (Multi-City, Certificates, Upgrades){' '}
            <img src={iconArrowRightSmall} alt=""></img>
          </AdvancedSearch>
        </Filters>

        <Locations>
          <InputWrapperNormal>
            <Label>From</Label>
            <Input type="text" defaultValue="New York City (NYC)" />
          </InputWrapperNormal>
          <IconArrow src={iconArrowsLeftRight} alt="" />
          <InputWrapperNormal>
            <Label>To</Label>
            <Input type="text" defaultValue="Dubai (DXB)" />
          </InputWrapperNormal>
        </Locations>

        <Dates>
          <InputWrapperNormal>
            <Label>Departing</Label>
            <Input type="text" defaultValue={todayFormated} />
            <CalenderIcon src={iconCalender} />
          </InputWrapperNormal>
          <IconArrow src={iconArrowRight} alt="" />
          <InputWrapperNormal>
            <Label>Returning</Label>
            <Input type="text" defaultValue={weekFromNowFromated} />
            <CalenderIcon src={iconCalender} />
          </InputWrapperNormal>
        </Dates>

        <Details>
          <ButtonGroup>
            <InputWrapperNarrow>
              <Label>Passenger(s)</Label>
              <Input type="text" size={3} defaultValue={1} />
            </InputWrapperNarrow>
            <InputWrapperNarrow>
              <Label>Class</Label>
              <Input type="text" size={9} defaultValue="Comfort" />
            </InputWrapperNarrow>
          </ButtonGroup>
          <FindFlightsButton>Find Flights</FindFlightsButton>
        </Details>
      </OptionsRow>
    </SearchFlightBox>
  )
}

export default PlanAndBook
